var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.clicked('From Modal Component')}}},[_vm._v("Modal Component")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }